import React from 'react'
import {
  Grid,
  GridCell,
  Flex,
  Title,
  SpacingVertical,
  FormElement,
  InputNumber,
  Text,
  Divider
} from 'mailup-web-components'
import { useIntl } from 'react-intl'
import iconTypography from '../../icons/cd-icon-typography.svg'
import styled from '@emotion/styled'
import { useRecoilValue, useSetRecoilState } from 'recoil'
import {
  defaultStyleState,
  pageState,
  styleState
} from 'Pages/EmailContentDefaults/recoil/state/state'
import FontFamilySelect from 'Pages/EmailContentDefaults/shared/FontFamilySelect'
import FontWeightSelect from 'Pages/EmailContentDefaults/shared/FontWeightSelect'
import { isNumber } from 'Pages/EmailContentDefaults/shared/utils'

const StyledIcon = styled.img`
  width: 24px;
  height: 24px;
  padding-right: 8px;
`
const StyledInputNumber = styled(InputNumber)`
  margin-right: 8px;
`

const StyleGrid = styled(Grid)`
  margin: 0 12px;
`

const ButtonTypography = () => {
  const intl = useIntl()
  const { button } = useRecoilValue(styleState)
  const { button: defaultButton } = useRecoilValue(defaultStyleState)
  const { isEnabled } = useRecoilValue(pageState)
  const setPageState = useSetRecoilState(pageState)
  const setStyleState = useSetRecoilState(styleState)

  const onChangeFontFamily = value => {
    setPageState(prev => ({
      ...prev,
      isDirty: true
    }))

    setStyleState(prev => ({
      ...prev,
      button: {
        ...prev.button,
        styles: {
          ...prev.button.styles,
          fontFamily: value || defaultButton.styles.fontFamily
        }
      }
    }))
  }

  const onChangeFontWeight = value => {
    setPageState(prev => ({
      ...prev,
      isDirty: true
    }))

    setStyleState(prev => ({
      ...prev,
      button: {
        ...prev.button,
        styles: {
          ...prev.button.styles,
          fontWeight: value || defaultButton.styles.fontWeight
        }
      }
    }))
  }

  const onChangeFontSize = value => {
    setPageState(prev => ({
      ...prev,
      isDirty: true
    }))

    setStyleState(prev => ({
      ...prev,
      button: {
        ...prev.button,
        styles: {
          ...prev.button.styles,
          fontSize: isNumber(value)
            ? value + 'px'
            : defaultButton.styles.fontSize
        }
      }
    }))
  }

  const onChangeLineHeight = value => {
    setPageState(prev => ({
      ...prev,
      isDirty: true
    }))

    setStyleState(prev => ({
      ...prev,
      button: {
        ...prev.button,
        styles: {
          ...prev.button.styles,
          lineHeight: isNumber(value)
            ? value + '%'
            : defaultButton.styles.lineHeight
        }
      }
    }))
  }

  return (
    <>
      <Flex alignItems='center'>
        <StyledIcon src={iconTypography} />
        <Title variant='M'>
          {intl.formatMessage({
            id: 'Load.ContentDefaults.CommonTypographyTitle'
          })}
        </Title>
      </Flex>
      <SpacingVertical variant='16' />
      <StyleGrid>
        <GridCell>
          <FormElement
            label={intl.formatMessage({
              id: 'Load.ContentDefaults.TypographyFontFamilyLabel'
            })}
          >
            <FontFamilySelect
              value={button.styles.fontFamily}
              onChange={onChangeFontFamily}
              disabled={!isEnabled}
            />
          </FormElement>
        </GridCell>
        <GridCell>
          <FormElement
            label={intl.formatMessage({
              id: 'Load.ContentDefaults.TypographyFontWeightLabel'
            })}
          >
            <FontWeightSelect
              value={+button.styles.fontWeight}
              onChange={onChangeFontWeight}
              disabled={!isEnabled}
            />
          </FormElement>
        </GridCell>
        <GridCell>
          <FormElement
            label={intl.formatMessage({
              id: 'Load.ContentDefaults.TypographyFontSizeLabel'
            })}
          >
            <Flex alignItems='center'>
              <StyledInputNumber
                min={1}
                value={parseInt(button.styles.fontSize.slice(0, -2))}
                onChange={onChangeFontSize}
                disabled={!isEnabled}
              />
              <Text>px</Text>
            </Flex>
          </FormElement>
        </GridCell>
        <GridCell>
          <FormElement
            label={intl.formatMessage({
              id: 'Load.ContentDefaults.TypographyLineHeightLabel'
            })}
          >
            <Flex alignItems='center'>
              <StyledInputNumber
                min={1}
                value={parseInt(button.styles.lineHeight.slice(0, -1))}
                onChange={onChangeLineHeight}
                disabled={!isEnabled}
              />
              <Text>%</Text>
            </Flex>
          </FormElement>
        </GridCell>
      </StyleGrid>
      <SpacingVertical />
      <Divider />
      <SpacingVertical />
    </>
  )
}

export default ButtonTypography
